
import game.Game
import game.Room
import game.entity.Entity

class Teleport : Entity(width = 1, height = 1) {
    private var roomName = ""
    private var roomRow = -1
    private var roomCol = -1

    override fun onInit(game: Game, room: Room) {
        val params = params.split(",")

        roomName = params[0]
        roomCol = params[1].toInt()
        roomRow = params[2].toInt()
    }

    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        game.startTeleportTransition(game.player.col, game.player.row, roomCol, roomRow, roomName, true)
        game.player.colVel = 0
        game.player.rowVel = 0

        return true
    }
}